export enum AuthStoreTypes {
    Buildertrend = 0,
    Auth0 = 1,
    BuildertrendADSAML = 2,
}

export class AuthStoreForUsername {
    constructor(data: any) {
        this.authStore = data.authStore;
        this.userExists = data.userExists ?? false;
        this.userCredentialsRemoved = data.userCredentialsRemoved ?? false;
        this.externalId = data.externalId;
        this.externalOrgLinkIds = data.externalOrgLinkIds;
    }

    authStore: AuthStoreTypes;
    userExists: boolean;
    userCredentialsRemoved: boolean;
    externalId?: string | null;
    externalOrgLinkIds?: string[] | null;
}

export interface IEmailUsernameEntryFormValues extends IMobileEmailUsernameEntryFormValues {
    emailReset: string;
}

export interface IMobileEmailUsernameEntryFormValues {
    userName: string;
    recaptchaToken: string | null;
}

export type EmailUsernameEntryActionType = "submit" | "forgotUsername" | undefined;

export enum EmailUsernameEntryScreen {
    EmailUsernameEntry = "emailUsernameEntry",
    ForgotUser = "forgotUser",
    ConfirmationUser = "confirmationUser",
}

export interface IPreviousAuthStoreInfo {
    authStore: AuthStoreTypes;
    username: string;
}
